module.exports = __webpack_public_path__ + "static/media/vid4.61ee32a5.PNG";